import { PopoverProps } from '@pypestream/design-system';
import { useId, useRef } from 'react';

export const useGenericPopover = () => {
  const popoverRef = useRef<PopoverProps>(null);

  const trigger = useId();

  const onClose = () => {
    if (popoverRef?.current) {
      popoverRef.current.active = false;
    }
  };

  return {
    trigger,
    popoverRef,
    onClose,
  };
};
